import ChevronUp from '@assets/icons/chevron-up.svg'
import { Icon } from './Icon'

export const ChevronUpIcon = Icon(ChevronUp)
